//
//
//
//

import foretell from "~/mixins/foretell.js";
import API from "~/api/api";
import orderCreatable from "~/mixins/orderCreateable.js";
import schemaHelpers from "~/mixins/schema-helpers.js";

export default {
  mixins: [foretell, orderCreatable, schemaHelpers],

  data() {
    return {
      pageInfo: {},
    };
  },

  async asyncData({ app, query, params, redirect, error }) {
    try {
      let pageSlug = "llc-2025";
      let pageInfo = await API.butterPages.get(app.$axios, pageSlug, {
        preview: query.preview ? 1 : 0,
      });
      return {
        pageInfo,
        loading: false,
        error: false,
      };
    } catch (e) {
      console.error(e);
      error({ message: "Error fetching data..." });

      return {
        loading: false,
      };
    }
  },

  head() {
    if (!this.loading || !this.error) {
      return {
        title: this.pageInfo.fields.meta_information.table.title,
        meta: [
          {
            name: "description",
            content: this.pageInfo.fields.meta_information.table.description,
          },
          {
            name: "keyword",
            content: this.pageInfo.fields.meta_information.table.keyword,
          },
        ],
      };
    } else {
      return {
        title: "Business Formation | LegalNature",
        meta: [
          { name: "description", content: "Business Formation" },
          { name: "keyword", content: "Business Formation" },
        ],
      };
    }
  },

  jsonld() {
    if (!this.loading || !this.error) {
      const baseSchema = {
        "@context": "https://schema.org",
        "@type": "Article",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": "https://www.legalnature.com/business-formation/llc",
        },
        headline: this.pageInfo.fields.meta_information.table.title,
        description: this.pageInfo.fields.meta_information.table.description,
        image: {
          "@type": "ImageObject",
          url: this.pageInfo.fields.meta_information.table["og-image"],
          width: "1200",
          height: "630",
        },
        keywords: this.pageInfo.fields.meta_information.table.keyword,
        inLanguage: "en-US",
        author: this.schemaAuthor,
        logo: this.schemaLogo,
        accessMode: "textual",
        accessModeSufficient: "textual",
        accessibilityAPI: "ARIA",
        isAccessibleForFree: true,
      };

      if (Array.isArray(this.schemaFaqs) && this.schemaFaqs.length > 0) {
        baseSchema.mainEntity = {
          "@type": "FAQPage",
          mainEntity: this.schemaFaqs.map((faq) => ({
            "@type": "Question",
            name: faq.table.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: this.stripHtmlTags(faq.table.answer),
            },
          })),
        };
      }

      if (Array.isArray(this.schemaSteps) && this.schemaSteps.length > 0) {
        baseSchema.step = {
          "@type": "HowTo",
          name: "How to Form an LLC",
          step: this.schemaSteps.map((step, index) => ({
            "@type": "HowToStep",
            position: index + 1,
            name: step.table.title,
            text: step.table.description,
          })),
        };
      }

      return baseSchema;
    }
    return null;
  },

  computed: {
    schemaFaqs() {
      return this.pageInfo.fields.page_body.find(
        (component) => component.table.type === "faqs"
      ).table.fields.table.faq;
    },
    schemaSteps() {
      return this.pageInfo.fields.page_body.find(
        (component) => component.table.type === "steps"
      ).table.fields.table.step;
    },
  },
};
